import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'src/features/auth/authSlice';

const HEAP_PROPERTY_CHAR_LIMIT = 1024;

export const useTelemetry = () => {
  const userData = useSelector(authSelectors.user);

  useEffect(() => {
    if (userData?.id) {
      const { id, role, email, first_name, last_name, properties, company_id } = userData;
      const property_features_enabled = [...userData.property_features_enabled];

      const userProperties = {
        role,
        email,
        first_name,
        last_name,
        company_id: company_id || 'None',
        property_features_enabled:
          property_features_enabled.join(',').slice(0, HEAP_PROPERTY_CHAR_LIMIT) || 'None',
        property_ids:
          properties
            .map((p) => p.short_id)
            .join(',')
            .slice(0, HEAP_PROPERTY_CHAR_LIMIT) || 'None',
        property_names:
          properties
            .map((p) => p.name)
            .join(',')
            .replaceAll(' ', '')
            .slice(0, HEAP_PROPERTY_CHAR_LIMIT) || 'None'
      };

      if (window.heap) {
        window.heap.identify(id);
        window.heap.addUserProperties(userProperties);
        // Clear event properties, so event properties from the our other apps using Heap don't get attached to the events here
        window.heap.clearEventProperties();
      }
      if (window.pendo) {
        window.pendo.initialize({
          visitor: {
            id,
            ...userProperties
          }
        });
      }
    }
  }, [userData]);
};
